module.exports = __webpack_public_path__ + "static/media/country_gg.c6414539.webp";